import React, { useEffect, useRef, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import { useSelector, useDispatch } from 'react-redux';
import { dispatchRecommend } from '../../../../store/search/actionCreator';
import { getQuery, getCookie } from '../../../../utils';
import { getCookies } from '../../../../utils/cookie';
import styles from './index.module.scss';

const defaultImg = <img src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif" alt='default img' />
const handleImgUrl = (url) => {
  //   if(Config.isSupportWebP && _self.hasClass("useWebP")) {
  // let original;
  //   if(original.indexOf(".jpg") > 0) {
  //       original = original.replace(/.jpg$/, ".jpg!q90.webp");
  //   } else if(original.indexOf(".png") > 0) {
  //       original = original.replace(/.png$/, ".png.webp");
  //   }
  // } else {
  const original = url.replace(/.jpg$/, ".jpg!q90");
  // }
  return original;
}
function Recommend() {
  const dispatch = useDispatch();
  const history = useHistory();
  const keyword = getQuery("keyword", history)
  const {
    allData,
    recommends = [],
    products,
    productsListStyle
  } = useSelector(state => state.searchReducer)

  const aLineNum = useRef(4);
  const lim = useMemo(() => {
    var itemNum = products.length;
    var lineNum = Math.ceil(itemNum / aLineNum.current);
    var lim = 3;
    if (productsListStyle == "item-style-v4") {
      if (lineNum <= 3) {
        lim = lineNum;
      } else if (lineNum > 3 && lineNum < 9) {
        lim = lineNum + 1;
      } else if (lineNum <= 12) {
        lim = lineNum + 2;
      }
    } else if (productsListStyle == "item-style-v3") {
      if (lineNum == 1) {
        lim = lineNum;
      } else if (lineNum > 1 && lineNum < 5) {
        lim = lineNum + 1;
      } else if (lineNum >= 5 && lineNum < 8) {
        lim = lineNum + 2;
      } else if (lineNum >= 8 && lineNum <= 12) {
        lim = lineNum + 3;
      }
    } else if (productsListStyle == "item-style-v1") {
      if (lineNum <= 2) {
        lim = lineNum;
      } else if (lineNum >= 3 && lineNum <= 5) {
        lim = lineNum + 1;
      } else if (lineNum <= 12) {
        lim = lineNum + 2;
      }
    }

    return lim;
  }, [productsListStyle, products, aLineNum])

  useEffect(() => {
    if(allData.skuRecommendPCSwitch !== 'ON') return;
    const data = {
      lid: 1,
      lim: lim,
      ec: 'utf-8',
      uuid: '',
      pin: getCookies("pin") || "",
      c1: '',
      c2: '',
      c3: '',
      sku: '',
      hi: `brand:,price:,keyword:${keyword}`,
      p: 619010
    }
    productsListStyle !== '' && dispatch(dispatchRecommend(data))
  }, [lim, productsListStyle, keyword, allData.skuRecommendPCSwitch])

  if (!recommends.length || allData.skuRecommendPCSwitch !== 'ON') return null;
  
  return (
    <div className={styles.recommend}>
      <div className={styles.title}>为您推荐</div>
      <div className={styles["r-list"]}>
        {
          recommends.map(item => (
            <div className={styles.item} key={item.sku}>
              <a href={`//npcitem.jd.hk/${item.sku}.html`} target="_blank" rel="noopener noreferrer">
                {/* overflow这个是关键点，会直接影响图片展示 */}
                <LazyLoad placeholder={defaultImg} scroll={true} overflow={true} scrollContainer={document.getElementById('root')}>
                  <img src={`//img11.360buyimg.com/n7/${handleImgUrl(item.img)}`} alt=''/>
                </LazyLoad>
              </a>
              <div className={styles.price}>
                <em>特价：</em>
                <span>{item.jp}</span>
              </div>
              <a href={`//npcitem.jd.hk/${item.sku}.html`} target="_blank" rel="noopener noreferrer" className={styles.name}>{item.t}</a>
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default Recommend;